import type {
  ICampaignTableAlimentBase,
  ICampaignTableBoxPaddingBase,
  ICampaignTableHeading,
} from './types';
import type { ReactNode } from 'react';

import { Header, Cell, Row, Property } from './components';
import { GCampaignTableProvider } from './contexts';
import { Box } from '@shopify/polaris';
import { useMemo } from 'react';
import { cls } from '~/utils';

import './GCampaignTable.scss';

export interface GCampaignTableBaseProps {
  listHeader: ICampaignTableHeading<string>[];
  children?: ReactNode;
  paddingTable?: ICampaignTableBoxPaddingBase;
  paddingRow?: ICampaignTableBoxPaddingBase;
  paddingCell?: ICampaignTableBoxPaddingBase;
  onClick?: (e?: React.MouseEvent) => void;
}

export const GCampaignTable = ({
  listHeader,
  children,
  onClick,
  ...props
}: GCampaignTableBaseProps) => {
  const defaultPaddingTable: ICampaignTableBoxPaddingBase = {
    paddingBlock: '400',
    paddingInline: '400',
  };
  const paddingTable = props.paddingTable
    ? { ...defaultPaddingTable, ...props.paddingTable }
    : defaultPaddingTable;

  const columnHead = useMemo(() => {
    return listHeader
      .map((heading) => {
        if (heading.isFlushLeft) return '';

        return heading.width ?? 'minmax(0, 1fr)';
      })
      .join(' ');
  }, [listHeader]);

  const columnBody = useMemo(() => {
    return listHeader
      .map((heading) => {
        return heading.width ?? 'minmax(0, 1fr)';
      })
      .join(' ');
  }, [listHeader]);

  const alignments: ICampaignTableAlimentBase[] = useMemo(() => {
    return listHeader.map((heading) => heading.alignment ?? 'start');
  }, [listHeader]);

  return (
    <GCampaignTableProvider
      columnHead={columnHead}
      columnBody={columnBody}
      alignments={alignments}
      listHeader={listHeader}
    >
      <div
        className={`${cls({
          'cursor-pointer': !!onClick,
        })}`}
        onClick={onClick}
      >
        <Box {...paddingTable}>
          <GCampaignTable.Row mode="head">
            <Header />
          </GCampaignTable.Row>
          <GCampaignTable.Property>{children}</GCampaignTable.Property>
        </Box>
      </div>
    </GCampaignTableProvider>
  );
};

GCampaignTable.Row = Row;
GCampaignTable.Property = Property;
GCampaignTable.Cell = Cell;
